export default __webpack_public_path__ + "static/media/art-2-main-md.50c48dea.jpg";